module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('em', [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/006_Figures#fm-1"
    }
  }, [_c('em', [_vm._v("List of Figures")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Tables#fm-2"
    }
  }, [_c('em', [_vm._v("List of Tables")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Foreword#fm-3"
    }
  }, [_c('em', [_vm._v("Foreword")]), _vm._v(" by Pheme Perkins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Preface#fm-4"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Acknowledgments#fm-5"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Abbreviations#fm-6"
    }
  }, [_c('em', [_vm._v("List of Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/012_EpigraphicConventions#fm-7"
    }
  }, [_c('em', [_vm._v("List of Epigraphic Conventions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm1"
  }, [_c('a', {
    attrs: {
      "href": "#/013_Introduction#fm-8"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter01#ch-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Imperial Divine Honors")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Imperial Divine Honors, Paul, and the Philippian Church")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Imperial Divine Honors, Paul, and the Thessalonian Church")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Imperial Divine Honors, Paul, and the Corinthian Church")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm1"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Conclusion#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Appendix01#bm-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Appendix 1: Inscriptions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Appendix02#bm-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Appendix 2: Reconstructed Julio-Claudian Imperial Calendar in Philippi and Corinth")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Bibliography#bm-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bibliography")])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb0fd014","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Contents.vue
// module id = 69
// module chunks = 0